import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close1",
  "use": "icon-close1-usage",
  "viewBox": "0 0 200 165",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 165\" id=\"icon-close1\">\r\n<style type=\"text/css\">\r\n</style>\r\n<g>\r\n\t<polygon class=\"st0\" points=\"90,46.7 47.9,2.2 3.8,2.2 67.3,69.4 \t\" />\r\n\t<polygon class=\"st0\" points=\"122.8,81.5 197.6,2.2 153.5,2.2 83.1,76.7 78.6,81.5 78.6,81.5 2,162.7 2.2,162.9 46,162.9 \r\n\t\t100.7,104.9 155.4,162.9 199.3,162.9 199.4,162.7 \t\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol